import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "resetPasswordForm",
    ref: "resetPasswordForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            "field-id": "emailField",
            label: _ctx.i18n.t('fields.emailaddress'),
            icon: "mdi-email-outline",
            type: "email",
            autocomplete: "username",
            rules: [_ctx.rules.required]
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.newpassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newpassword) = $event)),
            "field-id": "passwordField",
            label: _ctx.i18n.t('fields.newpassword'),
            icon: "mdi-lock-outline",
            type: "password",
            autocomplete: "new-password",
            rules: [_ctx.rules.password]
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.confirmpassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmpassword) = $event)),
            "field-id": "confirmPasswordField",
            label: _ctx.i18n.t('fields.confirmpassword'),
            icon: "mdi-lock-check-outline",
            type: "password",
            autocomplete: "new-password",
            rules: [_ctx.rules.password_match(_ctx.newpassword, _ctx.confirmpassword)]
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"text-align":"end"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqButton, {
            "button-id": "changePasswordButton",
            icon: "mdi-email-arrow-right-outline",
            "button-text": _ctx.i18n.t('buttons.changepassword'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetPassword(_ctx.email, _ctx.code, _ctx.newpassword)))
          }, null, 8, ["button-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}